/**
 * Champ numérique bornée. Un paramètre hors limites empêche l'action et
 * affiche l'erreur au niveau du champ concerné (section 17).
 */

import type { JSX } from 'preact';

export interface NumberFieldProps {
  readonly label: string;
  readonly value: number;
  readonly min: number;
  readonly max: number;
  readonly step?: number;
  readonly suffix?: string;
  readonly error?: string | undefined;
  readonly onChange: (value: number) => void;
}

export function NumberField(props: NumberFieldProps): JSX.Element {
  return (
    <label>
      <span class="field-label">
        {props.label}
        {props.suffix !== undefined ? ` (${props.suffix})` : ''}
      </span>
      <input
        type="number"
        inputMode="decimal"
        value={String(props.value)}
        min={props.min}
        max={props.max}
        step={props.step ?? 1}
        aria-invalid={props.error !== undefined}
        onInput={(event) => {
          const raw = (event.currentTarget as HTMLInputElement).value;
          const parsed = Number.parseFloat(raw.replace(',', '.'));
          if (Number.isFinite(parsed)) props.onChange(parsed);
        }}
      />
      {props.error !== undefined ? <span class="field-error">{props.error}</span> : null}
    </label>
  );
}
